/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.4.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import store from "@/core/store";
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from "axios";

export default abstract class AxiosClient {
  protected transformOptions(options: any): any {
    // Auth Bearer
    const token = store.state.currentUser?.accessToken;
    if (token) {
      options.headers["Authorization"] = `Bearer ${token}`;
    }

    // Add headers
    options.headers["api-version"] = "1.0";

    return Promise.resolve(options);
  }

  public getBaseUrl(val?: string): string {
    return process.env.VUE_APP_API_BASE_URL!;
  }
}

export class AdvancedSearchClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  advancedSearchReport(
    startDate: Date,
    endDate: Date,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/AdvancedSearch/Report/{startDate}/{endDate}";
    if (startDate === undefined || startDate === null)
      throw new Error("The parameter 'startDate' must be defined.");
    url_ = url_.replace(
      "{startDate}",
      encodeURIComponent(startDate ? "" + startDate.toISOString() : "null")
    );
    if (endDate === undefined || endDate === null)
      throw new Error("The parameter 'endDate' must be defined.");
    url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processAdvancedSearchReport(_response);
      });
  }

  protected processAdvancedSearchReport(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  advancedSearch(
    doctorId: string,
    searchTerm: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/AdvancedSearch/{doctorId}/{searchTerm}";
    if (doctorId === undefined || doctorId === null)
      throw new Error("The parameter 'doctorId' must be defined.");
    url_ = url_.replace("{doctorId}", encodeURIComponent("" + doctorId));
    if (searchTerm === undefined || searchTerm === null)
      throw new Error("The parameter 'searchTerm' must be defined.");
    url_ = url_.replace("{searchTerm}", encodeURIComponent("" + searchTerm));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processAdvancedSearch(_response);
      });
  }

  protected processAdvancedSearch(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class AuditClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  auditReport(startDate: Date, endDate: Date, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Audit/Report/{startDate}/{endDate}";
    if (startDate === undefined || startDate === null)
      throw new Error("The parameter 'startDate' must be defined.");
    url_ = url_.replace(
      "{startDate}",
      encodeURIComponent(startDate ? "" + startDate.toISOString() : "null")
    );
    if (endDate === undefined || endDate === null)
      throw new Error("The parameter 'endDate' must be defined.");
    url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processAuditReport(_response);
      });
  }

  protected processAuditReport(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class DoctorClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  doctorGET(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Doctor";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDoctorGET(_response);
      });
  }

  protected processDoctorGET(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  doctorPOST(body?: NewDoctorInfo | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Doctor";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDoctorPOST(_response);
      });
  }

  protected processDoctorPOST(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getDoctor(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Doctor/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetDoctor(_response);
      });
  }

  protected processGetDoctor(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  doctorPUT(
    id: string,
    body?: DoctorInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/Doctor/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDoctorPUT(_response);
      });
  }

  protected processDoctorPUT(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  doctorDELETE(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Doctor/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDoctorDELETE(_response);
      });
  }

  protected processDoctorDELETE(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getDoctorByAccessCode(
    accessCode: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/Doctor/accesscode/{accessCode}";
    if (accessCode === undefined || accessCode === null)
      throw new Error("The parameter 'accessCode' must be defined.");
    url_ = url_.replace("{accessCode}", encodeURIComponent("" + accessCode));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetDoctorByAccessCode(_response);
      });
  }

  protected processGetDoctorByAccessCode(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  authenticate(
    body?: DoctorTokenRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<TokenResponse> {
    let url_ = this.baseUrl + "/api/Doctor/Authenticate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processAuthenticate(_response);
      });
  }

  protected processAuthenticate(response: AxiosResponse<string>): Promise<TokenResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = TokenResponse.fromJS(resultData200);
      return Promise.resolve<TokenResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<TokenResponse>(<any>null);
  }
}

export class DoctorChildAccountClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  doctorChildAccountGET(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DoctorChildAccount";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDoctorChildAccountGET(_response);
      });
  }

  protected processDoctorChildAccountGET(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  doctorChildAccountPOST(
    body?: NewDoctorChildAccountInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/DoctorChildAccount";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDoctorChildAccountPOST(_response);
      });
  }

  protected processDoctorChildAccountPOST(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getDoctorChildAccount(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DoctorChildAccount/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetDoctorChildAccount(_response);
      });
  }

  protected processGetDoctorChildAccount(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  doctorChildAccountPUT(
    id: string,
    body?: DoctorChildAccountInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/DoctorChildAccount/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDoctorChildAccountPUT(_response);
      });
  }

  protected processDoctorChildAccountPUT(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  doctorChildAccountDELETE(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DoctorChildAccount/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDoctorChildAccountDELETE(_response);
      });
  }

  protected processDoctorChildAccountDELETE(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getDoctorChildAccountByAccessCode(
    accessCode: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/DoctorChildAccount/accesscode/{accessCode}";
    if (accessCode === undefined || accessCode === null)
      throw new Error("The parameter 'accessCode' must be defined.");
    url_ = url_.replace("{accessCode}", encodeURIComponent("" + accessCode));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetDoctorChildAccountByAccessCode(_response);
      });
  }

  protected processGetDoctorChildAccountByAccessCode(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  authenticate2(
    body?: DoctorChildAccountTokenRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<TokenResponse> {
    let url_ = this.baseUrl + "/api/DoctorChildAccount/Authenticate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processAuthenticate2(_response);
      });
  }

  protected processAuthenticate2(response: AxiosResponse<string>): Promise<TokenResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = TokenResponse.fromJS(resultData200);
      return Promise.resolve<TokenResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<TokenResponse>(<any>null);
  }
}

export class DoctorChildAccountTypeClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  doctorChildAccountTypeGET(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DoctorChildAccountType";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDoctorChildAccountTypeGET(_response);
      });
  }

  protected processDoctorChildAccountTypeGET(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  doctorChildAccountTypePOST(
    body?: NewDoctorChildAccountTypeInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/DoctorChildAccountType";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDoctorChildAccountTypePOST(_response);
      });
  }

  protected processDoctorChildAccountTypePOST(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getDoctorChildAccountType(id: number, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DoctorChildAccountType/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetDoctorChildAccountType(_response);
      });
  }

  protected processGetDoctorChildAccountType(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  doctorChildAccountTypePUT(
    id: number,
    body?: DoctorChildAccountTypeInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/DoctorChildAccountType/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDoctorChildAccountTypePUT(_response);
      });
  }

  protected processDoctorChildAccountTypePUT(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  doctorChildAccountTypeDELETE(id: number, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DoctorChildAccountType/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDoctorChildAccountTypeDELETE(_response);
      });
  }

  protected processDoctorChildAccountTypeDELETE(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class DrugClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  drugGET(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Drug";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDrugGET(_response);
      });
  }

  protected processDrugGET(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  drugPOST(body?: DrugInfo | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Drug";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDrugPOST(_response);
      });
  }

  protected processDrugPOST(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getDrug(drugIdentifier: string | null, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Drug/{drugIdentifier}";
    if (drugIdentifier === undefined || drugIdentifier === null)
      throw new Error("The parameter 'drugIdentifier' must be defined.");
    url_ = url_.replace("{drugIdentifier}", encodeURIComponent("" + drugIdentifier));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetDrug(_response);
      });
  }

  protected processGetDrug(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  drugPUT(
    drugIdentifier: string | null,
    body?: DrugInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/Drug/{drugIdentifier}";
    if (drugIdentifier === undefined || drugIdentifier === null)
      throw new Error("The parameter 'drugIdentifier' must be defined.");
    url_ = url_.replace("{drugIdentifier}", encodeURIComponent("" + drugIdentifier));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDrugPUT(_response);
      });
  }

  protected processDrugPUT(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  drugDELETE(drugIdentifier: string | null, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Drug/{drugIdentifier}";
    if (drugIdentifier === undefined || drugIdentifier === null)
      throw new Error("The parameter 'drugIdentifier' must be defined.");
    url_ = url_.replace("{drugIdentifier}", encodeURIComponent("" + drugIdentifier));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDrugDELETE(_response);
      });
  }

  protected processDrugDELETE(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  moveup(body?: DrugInfo | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Drug/moveup";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processMoveup(_response);
      });
  }

  protected processMoveup(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  movedown(body?: DrugInfo | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Drug/movedown";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processMovedown(_response);
      });
  }

  protected processMovedown(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class DrugOptionClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  drugOptionGET(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugOption";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDrugOptionGET(_response);
      });
  }

  protected processDrugOptionGET(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  drugOptionPOST(
    body?: DrugOptionInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugOption";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDrugOptionPOST(_response);
      });
  }

  protected processDrugOptionPOST(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getOptionsForDrug(
    drugIdentifier: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugOption/drug/{drugIdentifier}";
    if (drugIdentifier === undefined || drugIdentifier === null)
      throw new Error("The parameter 'drugIdentifier' must be defined.");
    url_ = url_.replace("{drugIdentifier}", encodeURIComponent("" + drugIdentifier));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetOptionsForDrug(_response);
      });
  }

  protected processGetOptionsForDrug(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getDrugOption(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugOption/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetDrugOption(_response);
      });
  }

  protected processGetDrugOption(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  drugOptionPUT(
    id: string,
    body?: DrugOptionInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugOption/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDrugOptionPUT(_response);
      });
  }

  protected processDrugOptionPUT(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  drugOptionDELETE(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugOption/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDrugOptionDELETE(_response);
      });
  }

  protected processDrugOptionDELETE(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class DrugPolicyClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  drugPolicyGET(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugPolicy";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDrugPolicyGET(_response);
      });
  }

  protected processDrugPolicyGET(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  drugPolicyPOST(
    body?: DrugPolicyInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugPolicy";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDrugPolicyPOST(_response);
      });
  }

  protected processDrugPolicyPOST(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getPoliciesForDrug(
    drugIdentifier: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugPolicy/drug/{drugIdentifier}";
    if (drugIdentifier === undefined || drugIdentifier === null)
      throw new Error("The parameter 'drugIdentifier' must be defined.");
    url_ = url_.replace("{drugIdentifier}", encodeURIComponent("" + drugIdentifier));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetPoliciesForDrug(_response);
      });
  }

  protected processGetPoliciesForDrug(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getDrugPolicy(id: number, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugPolicy/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetDrugPolicy(_response);
      });
  }

  protected processGetDrugPolicy(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  drugPolicyPUT(
    id: number,
    body?: DrugPolicyInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugPolicy/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDrugPolicyPUT(_response);
      });
  }

  protected processDrugPolicyPUT(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  drugPolicyDELETE(id: number, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugPolicy/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDrugPolicyDELETE(_response);
      });
  }

  protected processDrugPolicyDELETE(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class DrugPolicyOptionClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  list(drugPolicyId: number, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugPolicyOption/list/{drugPolicyId}";
    if (drugPolicyId === undefined || drugPolicyId === null)
      throw new Error("The parameter 'drugPolicyId' must be defined.");
    url_ = url_.replace("{drugPolicyId}", encodeURIComponent("" + drugPolicyId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processList(_response);
      });
  }

  protected processList(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getDrugPolicyOption(id: number, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugPolicyOption/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetDrugPolicyOption(_response);
      });
  }

  protected processGetDrugPolicyOption(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  deleteDrugPolicyOption(id: number, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugPolicyOption/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDeleteDrugPolicyOption(_response);
      });
  }

  protected processDeleteDrugPolicyOption(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  drugPolicyOption(
    body?: NewDrugPolicyOptionInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugPolicyOption";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDrugPolicyOption(_response);
      });
  }

  protected processDrugPolicyOption(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class DrugResponseOptionClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  drugResponseOptionGET(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugResponseOption";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDrugResponseOptionGET(_response);
      });
  }

  protected processDrugResponseOptionGET(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  drugResponseOptionPOST(
    body?: DrugResponseOptionInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugResponseOption";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDrugResponseOptionPOST(_response);
      });
  }

  protected processDrugResponseOptionPOST(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getForDrug(drugIdentifier: string | null, cancelToken?: CancelToken | undefined): Promise<void | any> {
    let url_ = this.baseUrl + "/api/DrugResponseOption/din/{drugIdentifier}";
    if (drugIdentifier === undefined || drugIdentifier === null)
      throw new Error("The parameter 'drugIdentifier' must be defined.");
    url_ = url_.replace("{drugIdentifier}", encodeURIComponent("" + drugIdentifier));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetForDrug(_response);
      });
  }

  protected processGetForDrug(response: AxiosResponse<string>): Promise<void | any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<string>(<any>_responseText);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getDrugResponseOption(id: number, cancelToken?: CancelToken | undefined): Promise<void | any> {
    let url_ = this.baseUrl + "/api/DrugResponseOption/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetDrugResponseOption(_response);
      });
  }

  protected processGetDrugResponseOption(response: AxiosResponse<string>): Promise<void | any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<string>(<any>_responseText);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  drugResponseOptionPUT(
    id: number,
    body?: DrugResponseOptionInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugResponseOption/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDrugResponseOptionPUT(_response);
      });
  }

  protected processDrugResponseOptionPUT(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  drugResponseOptionDELETE(id: number, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugResponseOption/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDrugResponseOptionDELETE(_response);
      });
  }

  protected processDrugResponseOptionDELETE(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  moveup2(id: number, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugResponseOption/moveup/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "POST",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processMoveup2(_response);
      });
  }

  protected processMoveup2(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  movedown2(id: number, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/DrugResponseOption/movedown/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "POST",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processMovedown2(_response);
      });
  }

  protected processMovedown2(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class ErrorClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @param body (optional)
   * @return Success
   */
  error(body?: ErrorDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Error";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processError(_response);
      });
  }

  protected processError(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class FileUploadClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  getFileUpload(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/FileUpload/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetFileUpload(_response);
      });
  }

  protected processGetFileUpload(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  downloadFile(id: string, cancelToken?: CancelToken | undefined): Promise<void | any> {
    let url_ = this.baseUrl + "/api/FileUpload/download/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processDownloadFile(_response);
      });
  }

  protected processDownloadFile(response: AxiosResponse<string>): Promise<void | any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<any>(<any>_responseText);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param photo (optional)
   * @return Success
   */
  fileUpload(
    position: string | null,
    reimbursementRequestId: string,
    photo?: FileParameter | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/FileUpload/update/{position}/{reimbursementRequestId}";
    if (position === undefined || position === null)
      throw new Error("The parameter 'position' must be defined.");
    url_ = url_.replace("{position}", encodeURIComponent("" + position));
    if (reimbursementRequestId === undefined || reimbursementRequestId === null)
      throw new Error("The parameter 'reimbursementRequestId' must be defined.");
    url_ = url_.replace("{reimbursementRequestId}", encodeURIComponent("" + reimbursementRequestId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (photo !== null && photo !== undefined)
      content_.append("photo", photo.data, photo.fileName ? photo.fileName : "photo");

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processFileUpload(_response);
      });
  }

  protected processFileUpload(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class InsuranceCompanyClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  insuranceCompanyGET(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/InsuranceCompany";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processInsuranceCompanyGET(_response);
      });
  }

  protected processInsuranceCompanyGET(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  insuranceCompanyPOST(
    body?: InsuranceCompanyInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/InsuranceCompany";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processInsuranceCompanyPOST(_response);
      });
  }

  protected processInsuranceCompanyPOST(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getInsuranceCompany(id: number, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/InsuranceCompany/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetInsuranceCompany(_response);
      });
  }

  protected processGetInsuranceCompany(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  insuranceCompanyPUT(
    id: number,
    body?: InsuranceCompanyInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/InsuranceCompany/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processInsuranceCompanyPUT(_response);
      });
  }

  protected processInsuranceCompanyPUT(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  insuranceCompanyDELETE(id: number, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/InsuranceCompany/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processInsuranceCompanyDELETE(_response);
      });
  }

  protected processInsuranceCompanyDELETE(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getInsuranceCompanyByName(
    name: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<void | any> {
    let url_ = this.baseUrl + "/api/InsuranceCompany/Name/{name}";
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.");
    url_ = url_.replace("{name}", encodeURIComponent("" + name));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetInsuranceCompanyByName(_response);
      });
  }

  protected processGetInsuranceCompanyByName(response: AxiosResponse<string>): Promise<void | any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<any>(<any>_responseText);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class NewsClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  newsGET(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/News";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processNewsGET(_response);
      });
  }

  protected processNewsGET(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  newsPOST(body?: NewsInfo | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/News";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processNewsPOST(_response);
      });
  }

  protected processNewsPOST(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getNews(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/News/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetNews(_response);
      });
  }

  protected processGetNews(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  newsPUT(
    id: string,
    body?: NewsInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/News/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processNewsPUT(_response);
      });
  }

  protected processNewsPUT(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  newsDELETE(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/News/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processNewsDELETE(_response);
      });
  }

  protected processNewsDELETE(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class PublicCoverageResponseClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  publicCoverageResponseGET(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/PublicCoverageResponse";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processPublicCoverageResponseGET(_response);
      });
  }

  protected processPublicCoverageResponseGET(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  publicCoverageResponsePOST(
    body?: NewPublicCoverageResponseInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/PublicCoverageResponse";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processPublicCoverageResponsePOST(_response);
      });
  }

  protected processPublicCoverageResponsePOST(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getPublicCoverageForDoctor(doctorId: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/PublicCoverageResponse/Doctor/{doctorId}";
    if (doctorId === undefined || doctorId === null)
      throw new Error("The parameter 'doctorId' must be defined.");
    url_ = url_.replace("{doctorId}", encodeURIComponent("" + doctorId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetPublicCoverageForDoctor(_response);
      });
  }

  protected processGetPublicCoverageForDoctor(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getPublicCoverageResponse(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/PublicCoverageResponse/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetPublicCoverageResponse(_response);
      });
  }

  protected processGetPublicCoverageResponse(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getPublicCoverageResponsesByDate(
    startDate: Date,
    endDate: Date,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/PublicCoverageResponse/{startDate}/{endDate}";
    if (startDate === undefined || startDate === null)
      throw new Error("The parameter 'startDate' must be defined.");
    url_ = url_.replace(
      "{startDate}",
      encodeURIComponent(startDate ? "" + startDate.toISOString() : "null")
    );
    if (endDate === undefined || endDate === null)
      throw new Error("The parameter 'endDate' must be defined.");
    url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetPublicCoverageResponsesByDate(_response);
      });
  }

  protected processGetPublicCoverageResponsesByDate(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class ReimbursementRequestClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  reimbursementRequestGET(cancelToken?: CancelToken | undefined): Promise<void | any> {
    let url_ = this.baseUrl + "/api/ReimbursementRequest";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processReimbursementRequestGET(_response);
      });
  }

  protected processReimbursementRequestGET(response: AxiosResponse<string>): Promise<void | string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<string>(_responseText);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  reimbursementRequestPOST(
    body?: NewReimbursementRequestInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/ReimbursementRequest";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processReimbursementRequestPOST(_response);
      });
  }

  protected processReimbursementRequestPOST(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getForDoctor(doctorId: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/ReimbursementRequest/Doctor/{doctorId}";
    if (doctorId === undefined || doctorId === null)
      throw new Error("The parameter 'doctorId' must be defined.");
    url_ = url_.replace("{doctorId}", encodeURIComponent("" + doctorId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetForDoctor(_response);
      });
  }

  protected processGetForDoctor(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getForDoctorChildAccount(
    doctorChildAccountId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/ReimbursementRequest/DoctorChildAccount/{doctorChildAccountId}";
    if (doctorChildAccountId === undefined || doctorChildAccountId === null)
      throw new Error("The parameter 'doctorChildAccountId' must be defined.");
    url_ = url_.replace("{doctorChildAccountId}", encodeURIComponent("" + doctorChildAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetForDoctorChildAccount(_response);
      });
  }

  protected processGetForDoctorChildAccount(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getByStatus(status: RequestStatus, cancelToken?: CancelToken | undefined): Promise<void | any> {
    let url_ = this.baseUrl + "/api/ReimbursementRequest/Status/{status}";
    if (status === undefined || status === null)
      throw new Error("The parameter 'status' must be defined.");
    url_ = url_.replace("{status}", encodeURIComponent("" + status));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetByStatus(_response);
      });
  }

  protected processGetByStatus(response: AxiosResponse<string>): Promise<void | any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<string>(_responseText);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getByStatusAndTime(
    status: RequestStatus,
    hours: number,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/ReimbursementRequest/Status/{status}/{hours}";
    if (status === undefined || status === null)
      throw new Error("The parameter 'status' must be defined.");
    url_ = url_.replace("{status}", encodeURIComponent("" + status));
    if (hours === undefined || hours === null) throw new Error("The parameter 'hours' must be defined.");
    url_ = url_.replace("{hours}", encodeURIComponent("" + hours));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetByStatusAndTime(_response);
      });
  }

  protected processGetByStatusAndTime(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getBySpecialAuthorizationStatus(
    status: SpecialAuthorizationFormStatus,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/ReimbursementRequest/SpecialAuthorizationStatus/{status}";
    if (status === undefined || status === null)
      throw new Error("The parameter 'status' must be defined.");
    url_ = url_.replace("{status}", encodeURIComponent("" + status));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetBySpecialAuthorizationStatus(_response);
      });
  }

  protected processGetBySpecialAuthorizationStatus(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getBySpecialAuthorizationStatusAndDateRange(
    status: SpecialAuthorizationFormStatus,
    startDate: Date,
    endDate: Date,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/ReimbursementRequest/SpecialAuthorizationStatus/{status}/{startDate}/{endDate}";
    if (status === undefined || status === null)
      throw new Error("The parameter 'status' must be defined.");
    url_ = url_.replace("{status}", encodeURIComponent("" + status));
    if (startDate === undefined || startDate === null)
      throw new Error("The parameter 'startDate' must be defined.");
    url_ = url_.replace(
      "{startDate}",
      encodeURIComponent(startDate ? "" + startDate.toISOString() : "null")
    );
    if (endDate === undefined || endDate === null)
      throw new Error("The parameter 'endDate' must be defined.");
    url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetBySpecialAuthorizationStatusAndDateRange(_response);
      });
  }

  protected processGetBySpecialAuthorizationStatusAndDateRange(
    response: AxiosResponse<string>
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  reportRequests(startDate: Date, endDate: Date, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/ReimbursementRequest/ReportRequests/{startDate}/{endDate}";
    if (startDate === undefined || startDate === null)
      throw new Error("The parameter 'startDate' must be defined.");
    url_ = url_.replace(
      "{startDate}",
      encodeURIComponent(startDate ? "" + startDate.toISOString() : "null")
    );
    if (endDate === undefined || endDate === null)
      throw new Error("The parameter 'endDate' must be defined.");
    url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processReportRequests(_response);
      });
  }

  protected processReportRequests(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getReimbursementRequest(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/ReimbursementRequest/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetReimbursementRequest(_response);
      });
  }

  protected processGetReimbursementRequest(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  reimbursementRequestPUT(
    id: string,
    body?: ReimbursementRequestInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void | any> {
    let url_ = this.baseUrl + "/api/ReimbursementRequest/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processReimbursementRequestPUT(_response);
      });
  }

  protected processReimbursementRequestPUT(response: AxiosResponse<string>): Promise<void | any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<any>(<any>_responseText);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class SpecialAuthorizationFormClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  specialAuthorizationFormGET(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/SpecialAuthorizationForm";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processSpecialAuthorizationFormGET(_response);
      });
  }

  protected processSpecialAuthorizationFormGET(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  specialAuthorizationFormPOST(
    body?: SpecialAuthorizationForm | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/SpecialAuthorizationForm";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processSpecialAuthorizationFormPOST(_response);
      });
  }

  protected processSpecialAuthorizationFormPOST(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getSpecialAuthorizationFormsForDrug(
    drugIdentifier: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<void | any> {
    let url_ = this.baseUrl + "/api/SpecialAuthorizationForm/din/{drugIdentifier}";
    if (drugIdentifier === undefined || drugIdentifier === null)
      throw new Error("The parameter 'drugIdentifier' must be defined.");
    url_ = url_.replace("{drugIdentifier}", encodeURIComponent("" + drugIdentifier));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetSpecialAuthorizationFormsForDrug(_response);
      });
  }

  protected processGetSpecialAuthorizationFormsForDrug(
    response: AxiosResponse<string>
  ): Promise<void | any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>_responseText);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getSpecialAuthorizationForm(id: number, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/SpecialAuthorizationForm/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetSpecialAuthorizationForm(_response);
      });
  }

  protected processGetSpecialAuthorizationForm(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  specialAuthorizationFormPUT(
    id: number,
    body?: SpecialAuthorizationForm | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/SpecialAuthorizationForm/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processSpecialAuthorizationFormPUT(_response);
      });
  }

  protected processSpecialAuthorizationFormPUT(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  specialAuthorizationFormDELETE(id: number, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/SpecialAuthorizationForm/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processSpecialAuthorizationFormDELETE(_response);
      });
  }

  protected processSpecialAuthorizationFormDELETE(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class SplashClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  splash(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Splash";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processSplash(_response);
      });
  }

  protected processSplash(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class UserClient extends AxiosClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super();
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
  }

  /**
   * @return Success
   */
  userGET(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/User";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processUserGET(_response);
      });
  }

  protected processUserGET(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  userPOST(body?: NewUserInfo | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/User";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processUserPOST(_response);
      });
  }

  protected processUserPOST(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getUsersByType(userType: UserType, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/User/type/{userType}";
    if (userType === undefined || userType === null)
      throw new Error("The parameter 'userType' must be defined.");
    url_ = url_.replace("{userType}", encodeURIComponent("" + userType));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetUsersByType(_response);
      });
  }

  protected processGetUsersByType(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getOnlinePharmacists(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/User/OnlinePharmacists";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetOnlinePharmacists(_response);
      });
  }

  protected processGetOnlinePharmacists(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getUser(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/User/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processGetUser(_response);
      });
  }

  protected processGetUser(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  userPUT(
    id: string,
    body?: UserInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/User/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processUserPUT(_response);
      });
  }

  protected processUserPUT(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  userDELETE(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/User/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processUserDELETE(_response);
      });
  }

  protected processUserDELETE(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  ping(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/User/Ping/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "PUT",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processPing(_response);
      });
  }

  protected processPing(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  userOnline(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    console.log("userOnline executed");

    let url_ = this.baseUrl + "/api/User/UserOnline/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "PUT",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processUserOnline(_response);
      });
  }

  protected processUserOnline(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  userOffline(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
    console.log("userOffline executed");

    let url_ = this.baseUrl + "/api/User/UserOffline/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "PUT",
      url: url_,
      headers: {},
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processUserOffline(_response);
      });
  }

  protected processUserOffline(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  authenticate(
    body?: UserTokenRequest | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<TokenResponse> {
    let url_ = this.baseUrl + "/api/User/Authenticate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processAuthenticate(_response);
      });
  }

  protected processAuthenticate(response: AxiosResponse<string>): Promise<TokenResponse | any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = TokenResponse.fromJS(resultData200);
      return Promise.resolve<TokenResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<TokenResponse>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  changePassword(
    body?: ChangePasswordInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/User/ChangePassword";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processChangePassword(_response);
      });
  }

  protected processChangePassword(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  changeUserPassword(
    body?: ChangeUserPasswordInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/User/ChangeUserPassword";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processChangeUserPassword(_response);
      });
  }

  protected processChangeUserPassword(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  initiateResetPassword(
    body?: InitiateResetPasswordInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/User/InitiateResetPassword";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processInitiateResetPassword(_response);
      });
  }

  protected processInitiateResetPassword(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  completeResetPassword(
    body?: ResetPasswordInfo | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/User/CompleteResetPassword";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      cancelToken
    };

    return this.transformOptions(options_)
      .then((transformedOptions_: AxiosRequestConfig<any>) => {
        return this.instance.request(transformedOptions_);
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse<string>) => {
        return this.processCompleteResetPassword(_response);
      });
  }

  protected processCompleteResetPassword(response: AxiosResponse<string>): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }
}

export enum Province {
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
  _7 = 7,
  _8 = 8,
  _9 = 9,
  _10 = 10,
  _11 = 11,
  _12 = 12,
  _13 = 13
}

export class NewDoctorInfo implements INewDoctorInfo {
  applicationId?: string;
  firstName?: string | undefined;
  lastName?: string | undefined;
  province?: Province;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  cpsoNumber?: string | undefined;
  email?: string | undefined;
  deviceToken?: string | undefined;
  accessCode?: string | undefined;

  constructor(data?: INewDoctorInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.applicationId = _data["applicationId"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.province = _data["province"];
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.cpsoNumber = _data["cpsoNumber"];
      this.email = _data["email"];
      this.deviceToken = _data["deviceToken"];
      this.accessCode = _data["accessCode"];
    }
  }

  static fromJS(data: any): NewDoctorInfo {
    data = typeof data === "object" ? data : {};
    let result = new NewDoctorInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["applicationId"] = this.applicationId;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["province"] = this.province;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["cpsoNumber"] = this.cpsoNumber;
    data["email"] = this.email;
    data["deviceToken"] = this.deviceToken;
    data["accessCode"] = this.accessCode;
    return data;
  }
}

export interface INewDoctorInfo {
  applicationId?: string;
  firstName?: string | undefined;
  lastName?: string | undefined;
  province?: Province;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  cpsoNumber?: string | undefined;
  email?: string | undefined;
  deviceToken?: string | undefined;
  accessCode?: string | undefined;
}

export class DoctorInfo implements IDoctorInfo {
  firstName?: string | undefined;
  lastName?: string | undefined;
  province?: Province;
  cpsoNumber?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  deviceToken?: string | undefined;
  accessCode?: string | undefined;

  constructor(data?: IDoctorInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.province = _data["province"];
      this.cpsoNumber = _data["cpsoNumber"];
      this.email = _data["email"];
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.deviceToken = _data["deviceToken"];
      this.accessCode = _data["accessCode"];
    }
  }

  static fromJS(data: any): DoctorInfo {
    data = typeof data === "object" ? data : {};
    let result = new DoctorInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["province"] = this.province;
    data["cpsoNumber"] = this.cpsoNumber;
    data["email"] = this.email;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["deviceToken"] = this.deviceToken;
    data["accessCode"] = this.accessCode;
    return data;
  }
}

export interface IDoctorInfo {
  firstName?: string | undefined;
  lastName?: string | undefined;
  province?: Province;
  cpsoNumber?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  deviceToken?: string | undefined;
  accessCode?: string | undefined;
}

export class DoctorTokenRequest implements IDoctorTokenRequest {
  cpsoNumber!: string;
  doctorID!: string;

  constructor(data?: IDoctorTokenRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.cpsoNumber = _data["cpsoNumber"];
      this.doctorID = _data["doctorID"];
    }
  }

  static fromJS(data: any): DoctorTokenRequest {
    data = typeof data === "object" ? data : {};
    let result = new DoctorTokenRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["cpsoNumber"] = this.cpsoNumber;
    data["doctorID"] = this.doctorID;
    return data;
  }
}

export interface IDoctorTokenRequest {
  cpsoNumber: string;
  doctorID: string;
}

export class TokenResponse implements ITokenResponse {
  accountID?: string;
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  accessToken?: string | undefined;
  role?: string | undefined;

  constructor(data?: ITokenResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accountID = _data["accountID"];
      this.email = _data["email"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.accessToken = _data["accessToken"];
      this.role = _data["role"];
    }
  }

  static fromJS(data: any): TokenResponse {
    data = typeof data === "object" ? data : {};
    let result = new TokenResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["accountID"] = this.accountID;
    data["email"] = this.email;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["accessToken"] = this.accessToken;
    data["role"] = this.role;
    return data;
  }
}

export interface ITokenResponse {
  accountID?: string;
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  accessToken?: string | undefined;
  role?: string | undefined;
}

export class NewDoctorChildAccountInfo implements INewDoctorChildAccountInfo {
  applicationId?: string;
  doctorID?: string;
  doctorChildAccountTypeID?: number;
  parentID?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  deviceToken?: string | undefined;
  accessCode?: string | undefined;

  constructor(data?: INewDoctorChildAccountInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.applicationId = _data["applicationId"];
      this.doctorID = _data["doctorID"];
      this.doctorChildAccountTypeID = _data["doctorChildAccountTypeID"];
      this.parentID = _data["parentID"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.email = _data["email"];
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.deviceToken = _data["deviceToken"];
      this.accessCode = _data["accessCode"];
    }
  }

  static fromJS(data: any): NewDoctorChildAccountInfo {
    data = typeof data === "object" ? data : {};
    let result = new NewDoctorChildAccountInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["applicationId"] = this.applicationId;
    data["doctorID"] = this.doctorID;
    data["doctorChildAccountTypeID"] = this.doctorChildAccountTypeID;
    data["parentID"] = this.parentID;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["email"] = this.email;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["deviceToken"] = this.deviceToken;
    data["accessCode"] = this.accessCode;
    return data;
  }
}

export interface INewDoctorChildAccountInfo {
  applicationId?: string;
  doctorID?: string;
  doctorChildAccountTypeID?: number;
  parentID?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  deviceToken?: string | undefined;
  accessCode?: string | undefined;
}

export class DoctorChildAccountInfo implements IDoctorChildAccountInfo {
  doctorID?: string;
  doctorChildAccountTypeID?: number;
  parentID?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  deviceToken?: string | undefined;
  accessCode?: string | undefined;

  constructor(data?: IDoctorChildAccountInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.doctorID = _data["doctorID"];
      this.doctorChildAccountTypeID = _data["doctorChildAccountTypeID"];
      this.parentID = _data["parentID"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.email = _data["email"];
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.deviceToken = _data["deviceToken"];
      this.accessCode = _data["accessCode"];
    }
  }

  static fromJS(data: any): DoctorChildAccountInfo {
    data = typeof data === "object" ? data : {};
    let result = new DoctorChildAccountInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["doctorID"] = this.doctorID;
    data["doctorChildAccountTypeID"] = this.doctorChildAccountTypeID;
    data["parentID"] = this.parentID;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["email"] = this.email;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["deviceToken"] = this.deviceToken;
    data["accessCode"] = this.accessCode;
    return data;
  }
}

export interface IDoctorChildAccountInfo {
  doctorID?: string;
  doctorChildAccountTypeID?: number;
  parentID?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  deviceToken?: string | undefined;
  accessCode?: string | undefined;
}

export class DoctorChildAccountTokenRequest implements IDoctorChildAccountTokenRequest {
  doctorChildAccountID!: string;

  constructor(data?: IDoctorChildAccountTokenRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.doctorChildAccountID = _data["doctorChildAccountID"];
    }
  }

  static fromJS(data: any): DoctorChildAccountTokenRequest {
    data = typeof data === "object" ? data : {};
    let result = new DoctorChildAccountTokenRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["doctorChildAccountID"] = this.doctorChildAccountID;
    return data;
  }
}

export interface IDoctorChildAccountTokenRequest {
  doctorChildAccountID: string;
}

export class NewDoctorChildAccountTypeInfo implements INewDoctorChildAccountTypeInfo {
  name?: string | undefined;
  isPatient?: boolean;

  constructor(data?: INewDoctorChildAccountTypeInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.isPatient = _data["isPatient"];
    }
  }

  static fromJS(data: any): NewDoctorChildAccountTypeInfo {
    data = typeof data === "object" ? data : {};
    let result = new NewDoctorChildAccountTypeInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["isPatient"] = this.isPatient;
    return data;
  }
}

export interface INewDoctorChildAccountTypeInfo {
  name?: string | undefined;
  isPatient?: boolean;
}

export class DoctorChildAccountTypeInfo implements IDoctorChildAccountTypeInfo {
  doctorChildAccountTypeID?: number;
  name?: string | undefined;
  isPatient?: boolean;

  constructor(data?: IDoctorChildAccountTypeInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.doctorChildAccountTypeID = _data["doctorChildAccountTypeID"];
      this.name = _data["name"];
      this.isPatient = _data["isPatient"];
    }
  }

  static fromJS(data: any): DoctorChildAccountTypeInfo {
    data = typeof data === "object" ? data : {};
    let result = new DoctorChildAccountTypeInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["doctorChildAccountTypeID"] = this.doctorChildAccountTypeID;
    data["name"] = this.name;
    data["isPatient"] = this.isPatient;
    return data;
  }
}

export interface IDoctorChildAccountTypeInfo {
  doctorChildAccountTypeID?: number;
  name?: string | undefined;
  isPatient?: boolean;
}

export enum EntityStatus {
  _0 = 0,
  _1 = 1,
  _2 = 2
}

export class DrugInfo implements IDrugInfo {
  drugIdentifier?: string | undefined;
  name?: string | undefined;
  photoUrl?: string | undefined;
  status?: EntityStatus;
  notes?: string | undefined;
  keyInformation?: string | undefined;
  otherConsiderations?: string | undefined;
  moreInformationUrl?: string | undefined;
  patientInformation?: string | undefined;

  constructor(data?: IDrugInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.drugIdentifier = _data["drugIdentifier"];
      this.name = _data["name"];
      this.photoUrl = _data["photoUrl"];
      this.status = _data["status"];
      this.notes = _data["notes"];
      this.keyInformation = _data["keyInformation"];
      this.otherConsiderations = _data["otherConsiderations"];
      this.moreInformationUrl = _data["moreInformationUrl"];
      this.patientInformation = _data["patientInformation"];
    }
  }

  static fromJS(data: any): DrugInfo {
    data = typeof data === "object" ? data : {};
    let result = new DrugInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["drugIdentifier"] = this.drugIdentifier;
    data["name"] = this.name;
    data["photoUrl"] = this.photoUrl;
    data["status"] = this.status;
    data["notes"] = this.notes;
    data["keyInformation"] = this.keyInformation;
    data["otherConsiderations"] = this.otherConsiderations;
    data["moreInformationUrl"] = this.moreInformationUrl;
    data["patientInformation"] = this.patientInformation;
    return data;
  }
}

export interface IDrugInfo {
  drugIdentifier?: string | undefined;
  name?: string | undefined;
  photoUrl?: string | undefined;
  status?: EntityStatus;
  notes?: string | undefined;
  keyInformation?: string | undefined;
  otherConsiderations?: string | undefined;
  moreInformationUrl?: string | undefined;
  patientInformation?: string | undefined;
}

export class DrugOptionInfo implements IDrugOptionInfo {
  drugOptionID?: string | undefined;
  drugIdentifier?: string | undefined;
  din?: string | undefined;
  name?: string | undefined;
  dosingRecommendations?: string | undefined;
  isDefault?: boolean;

  constructor(data?: IDrugOptionInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.drugOptionID = _data["drugOptionID"];
      this.drugIdentifier = _data["drugIdentifier"];
      this.din = _data["din"];
      this.name = _data["name"];
      this.dosingRecommendations = _data["dosingRecommendations"];
      this.isDefault = _data["isDefault"];
    }
  }

  static fromJS(data: any): DrugOptionInfo {
    data = typeof data === "object" ? data : {};
    let result = new DrugOptionInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["drugOptionID"] = this.drugOptionID;
    data["drugIdentifier"] = this.drugIdentifier;
    data["din"] = this.din;
    data["name"] = this.name;
    data["dosingRecommendations"] = this.dosingRecommendations;
    data["isDefault"] = this.isDefault;
    return data;
  }
}

export interface IDrugOptionInfo {
  drugOptionID?: string | undefined;
  drugIdentifier?: string | undefined;
  din?: string | undefined;
  name?: string | undefined;
  dosingRecommendations?: string | undefined;
  isDefault?: boolean;
}

export enum DrugPolicyType {
  _1 = 1,
  _2 = 2
}

export class DrugPolicyInfo implements IDrugPolicyInfo {
  province?: Province;
  drugIdentifier?: string | undefined;
  policyType?: DrugPolicyType;
  minAge?: number | undefined;
  maxAge?: number | undefined;
  notes?: string | undefined;

  constructor(data?: IDrugPolicyInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.province = _data["province"];
      this.drugIdentifier = _data["drugIdentifier"];
      this.policyType = _data["policyType"];
      this.minAge = _data["minAge"];
      this.maxAge = _data["maxAge"];
      this.notes = _data["notes"];
    }
  }

  static fromJS(data: any): DrugPolicyInfo {
    data = typeof data === "object" ? data : {};
    let result = new DrugPolicyInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["province"] = this.province;
    data["drugIdentifier"] = this.drugIdentifier;
    data["policyType"] = this.policyType;
    data["minAge"] = this.minAge;
    data["maxAge"] = this.maxAge;
    data["notes"] = this.notes;
    return data;
  }
}

export interface IDrugPolicyInfo {
  province?: Province;
  drugIdentifier?: string | undefined;
  policyType?: DrugPolicyType;
  minAge?: number | undefined;
  maxAge?: number | undefined;
  notes?: string | undefined;
}

export class NewDrugPolicyOptionInfo implements INewDrugPolicyOptionInfo {
  drugPolicyID?: number;
  drugOptionID?: string;

  constructor(data?: INewDrugPolicyOptionInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.drugPolicyID = _data["drugPolicyID"];
      this.drugOptionID = _data["drugOptionID"];
    }
  }

  static fromJS(data: any): NewDrugPolicyOptionInfo {
    data = typeof data === "object" ? data : {};
    let result = new NewDrugPolicyOptionInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["drugPolicyID"] = this.drugPolicyID;
    data["drugOptionID"] = this.drugOptionID;
    return data;
  }
}

export interface INewDrugPolicyOptionInfo {
  drugPolicyID?: number;
  drugOptionID?: string;
}

export class DrugResponseOptionInfo implements IDrugResponseOptionInfo {
  drugIdentifier?: string | undefined;
  position?: number;
  title?: string | undefined;
  notes?: string | undefined;
  header?: string | undefined;
  footer?: string | undefined;
  isOther?: boolean;
  isSpecialAuth?: boolean;
  province?: Province;

  constructor(data?: IDrugResponseOptionInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.drugIdentifier = _data["drugIdentifier"];
      this.position = _data["position"];
      this.title = _data["title"];
      this.notes = _data["notes"];
      this.header = _data["header"];
      this.footer = _data["footer"];
      this.isOther = _data["isOther"];
      this.isSpecialAuth = _data["isSpecialAuth"];
      this.province = _data["province"];
    }
  }

  static fromJS(data: any): DrugResponseOptionInfo {
    data = typeof data === "object" ? data : {};
    let result = new DrugResponseOptionInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["drugIdentifier"] = this.drugIdentifier;
    data["position"] = this.position;
    data["title"] = this.title;
    data["notes"] = this.notes;
    data["header"] = this.header;
    data["footer"] = this.footer;
    data["isOther"] = this.isOther;
    data["isSpecialAuth"] = this.isSpecialAuth;
    data["province"] = this.province;
    return data;
  }
}

export interface IDrugResponseOptionInfo {
  drugIdentifier?: string | undefined;
  position?: number;
  title?: string | undefined;
  notes?: string | undefined;
  header?: string | undefined;
  footer?: string | undefined;
  isOther?: boolean;
  isSpecialAuth?: boolean;
  province?: Province;
}

export class ErrorDto implements IErrorDto {
  errorID?: number;
  errorType?: string | undefined;
  message?: string | undefined;
  stackTrace?: string | undefined;
  user?: string | undefined;
  createdOn?: Date;

  constructor(data?: IErrorDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.errorID = _data["errorID"];
      this.errorType = _data["errorType"];
      this.message = _data["message"];
      this.stackTrace = _data["stackTrace"];
      this.user = _data["user"];
      this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): ErrorDto {
    data = typeof data === "object" ? data : {};
    let result = new ErrorDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["errorID"] = this.errorID;
    data["errorType"] = this.errorType;
    data["message"] = this.message;
    data["stackTrace"] = this.stackTrace;
    data["user"] = this.user;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
    return data;
  }
}

export interface IErrorDto {
  errorID?: number;
  errorType?: string | undefined;
  message?: string | undefined;
  stackTrace?: string | undefined;
  user?: string | undefined;
  createdOn?: Date;
}

export class InsuranceCompanyInfo implements IInsuranceCompanyInfo {
  companyName?: string | undefined;
  status?: EntityStatus;
  adjudicator?: string | undefined;
  carrierId?: string | undefined;
  clientIdName?: string | undefined;
  clientIdFormat?: string | undefined;
  groupIdName?: string | undefined;
  groupIdFormat?: string | undefined;
  thirdFieldName?: string | undefined;
  thirdFieldFormat?: string | undefined;
  forthFieldName?: string | undefined;
  forthFieldFormat?: string | undefined;
  fifthFieldName?: string | undefined;
  fifthFieldFormat?: string | undefined;
  sixthFieldName?: string | undefined;
  sixthFieldFormat?: string | undefined;

  constructor(data?: IInsuranceCompanyInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyName = _data["companyName"];
      this.status = _data["status"];
      this.adjudicator = _data["adjudicator"];
      this.carrierId = _data["carrierId"];
      this.clientIdName = _data["clientIdName"];
      this.clientIdFormat = _data["clientIdFormat"];
      this.groupIdName = _data["groupIdName"];
      this.groupIdFormat = _data["groupIdFormat"];
      this.thirdFieldName = _data["thirdFieldName"];
      this.thirdFieldFormat = _data["thirdFieldFormat"];
      this.forthFieldName = _data["forthFieldName"];
      this.forthFieldFormat = _data["forthFieldFormat"];
      this.fifthFieldName = _data["fifthFieldName"];
      this.fifthFieldFormat = _data["fifthFieldFormat"];
      this.sixthFieldName = _data["sixthFieldName"];
      this.sixthFieldFormat = _data["sixthFieldFormat"];
    }
  }

  static fromJS(data: any): InsuranceCompanyInfo {
    data = typeof data === "object" ? data : {};
    let result = new InsuranceCompanyInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["companyName"] = this.companyName;
    data["status"] = this.status;
    data["adjudicator"] = this.adjudicator;
    data["carrierId"] = this.carrierId;
    data["clientIdName"] = this.clientIdName;
    data["clientIdFormat"] = this.clientIdFormat;
    data["groupIdName"] = this.groupIdName;
    data["groupIdFormat"] = this.groupIdFormat;
    data["thirdFieldName"] = this.thirdFieldName;
    data["thirdFieldFormat"] = this.thirdFieldFormat;
    data["forthFieldName"] = this.forthFieldName;
    data["forthFieldFormat"] = this.forthFieldFormat;
    data["fifthFieldName"] = this.fifthFieldName;
    data["fifthFieldFormat"] = this.fifthFieldFormat;
    data["sixthFieldName"] = this.sixthFieldName;
    data["sixthFieldFormat"] = this.sixthFieldFormat;
    return data;
  }
}

export interface IInsuranceCompanyInfo {
  companyName?: string | undefined;
  status?: EntityStatus;
  adjudicator?: string | undefined;
  carrierId?: string | undefined;
  clientIdName?: string | undefined;
  clientIdFormat?: string | undefined;
  groupIdName?: string | undefined;
  groupIdFormat?: string | undefined;
  thirdFieldName?: string | undefined;
  thirdFieldFormat?: string | undefined;
  forthFieldName?: string | undefined;
  forthFieldFormat?: string | undefined;
  fifthFieldName?: string | undefined;
  fifthFieldFormat?: string | undefined;
  sixthFieldName?: string | undefined;
  sixthFieldFormat?: string | undefined;
}

export class NewsInfo implements INewsInfo {
  newsID?: string;
  status?: EntityStatus;
  title?: string | undefined;
  content?: string | undefined;
  createdOn?: Date;

  constructor(data?: INewsInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.newsID = _data["newsID"];
      this.status = _data["status"];
      this.title = _data["title"];
      this.content = _data["content"];
      this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): NewsInfo {
    data = typeof data === "object" ? data : {};
    let result = new NewsInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["newsID"] = this.newsID;
    data["status"] = this.status;
    data["title"] = this.title;
    data["content"] = this.content;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
    return data;
  }
}

export interface INewsInfo {
  newsID?: string;
  status?: EntityStatus;
  title?: string | undefined;
  content?: string | undefined;
  createdOn?: Date;
}

export class NewPublicCoverageResponseInfo implements INewPublicCoverageResponseInfo {
  patientFirstName?: string | undefined;
  patientLastName?: string | undefined;
  dateOfBirth?: Date;
  province?: Province;
  drugIdentifier?: string | undefined;
  drugPolicyID?: number;
  doctorID?: string;

  constructor(data?: INewPublicCoverageResponseInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.patientFirstName = _data["patientFirstName"];
      this.patientLastName = _data["patientLastName"];
      this.dateOfBirth = _data["dateOfBirth"]
        ? new Date(_data["dateOfBirth"].toString())
        : <any>undefined;
      this.province = _data["province"];
      this.drugIdentifier = _data["drugIdentifier"];
      this.drugPolicyID = _data["drugPolicyID"];
      this.doctorID = _data["doctorID"];
    }
  }

  static fromJS(data: any): NewPublicCoverageResponseInfo {
    data = typeof data === "object" ? data : {};
    let result = new NewPublicCoverageResponseInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["patientFirstName"] = this.patientFirstName;
    data["patientLastName"] = this.patientLastName;
    data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
    data["province"] = this.province;
    data["drugIdentifier"] = this.drugIdentifier;
    data["drugPolicyID"] = this.drugPolicyID;
    data["doctorID"] = this.doctorID;
    return data;
  }
}

export interface INewPublicCoverageResponseInfo {
  patientFirstName?: string | undefined;
  patientLastName?: string | undefined;
  dateOfBirth?: Date;
  province?: Province;
  drugIdentifier?: string | undefined;
  drugPolicyID?: number;
  doctorID?: string;
}

export class NewReimbursementRequestInfo implements INewReimbursementRequestInfo {
  doctorID?: string;
  doctorChildAccountID?: string | undefined;
  insuranceCompanyName?: string | undefined;
  clientID?: string | undefined;
  groupID?: string | undefined;
  thirdFieldID?: string | undefined;
  forthFieldID?: string | undefined;
  fifthFieldID?: string | undefined;
  sixthFieldID?: string | undefined;
  province?: Province;
  patientFirstName?: string | undefined;
  patientLastName?: string | undefined;
  patientRelationToCardHolder?: string | undefined;
  drugIdentifier?: string | undefined;
  dateOfBirth?: Date;
  din?: string | undefined;
  optionName?: string | undefined;

  constructor(data?: INewReimbursementRequestInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.doctorID = _data["doctorID"];
      this.doctorChildAccountID = _data["doctorChildAccountID"];
      this.insuranceCompanyName = _data["insuranceCompanyName"];
      this.clientID = _data["clientID"];
      this.groupID = _data["groupID"];
      this.thirdFieldID = _data["thirdFieldID"];
      this.forthFieldID = _data["forthFieldID"];
      this.fifthFieldID = _data["fifthFieldID"];
      this.sixthFieldID = _data["sixthFieldID"];
      this.province = _data["province"];
      this.patientFirstName = _data["patientFirstName"];
      this.patientLastName = _data["patientLastName"];
      this.patientRelationToCardHolder = _data["patientRelationToCardHolder"];
      this.drugIdentifier = _data["drugIdentifier"];
      this.dateOfBirth = _data["dateOfBirth"]
        ? new Date(_data["dateOfBirth"].toString())
        : <any>undefined;
      this.din = _data["din"];
      this.optionName = _data["optionName"];
    }
  }

  static fromJS(data: any): NewReimbursementRequestInfo {
    data = typeof data === "object" ? data : {};
    let result = new NewReimbursementRequestInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["doctorID"] = this.doctorID;
    data["doctorChildAccountID"] = this.doctorChildAccountID;
    data["insuranceCompanyName"] = this.insuranceCompanyName;
    data["clientID"] = this.clientID;
    data["groupID"] = this.groupID;
    data["thirdFieldID"] = this.thirdFieldID;
    data["forthFieldID"] = this.forthFieldID;
    data["fifthFieldID"] = this.fifthFieldID;
    data["sixthFieldID"] = this.sixthFieldID;
    data["province"] = this.province;
    data["patientFirstName"] = this.patientFirstName;
    data["patientLastName"] = this.patientLastName;
    data["patientRelationToCardHolder"] = this.patientRelationToCardHolder;
    data["drugIdentifier"] = this.drugIdentifier;
    data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
    data["din"] = this.din;
    data["optionName"] = this.optionName;
    return data;
  }
}

export interface INewReimbursementRequestInfo {
  doctorID?: string;
  doctorChildAccountID?: string | undefined;
  insuranceCompanyName?: string | undefined;
  clientID?: string | undefined;
  groupID?: string | undefined;
  thirdFieldID?: string | undefined;
  forthFieldID?: string | undefined;
  fifthFieldID?: string | undefined;
  sixthFieldID?: string | undefined;
  province?: Province;
  patientFirstName?: string | undefined;
  patientLastName?: string | undefined;
  patientRelationToCardHolder?: string | undefined;
  drugIdentifier?: string | undefined;
  dateOfBirth?: Date;
  din?: string | undefined;
  optionName?: string | undefined;
}

export enum RequestStatus {
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4
}

export enum SpecialAuthorizationFormStatus {
  _0 = 0,
  _1 = 1,
  _2 = 2
}

export class ReimbursementRequestInfo implements IReimbursementRequestInfo {
  doctorID?: string;
  doctorChildAccountID?: string | undefined;
  pharmacistUserID?: string | undefined;
  insuranceCompanyName?: string | undefined;
  clientID?: string | undefined;
  groupID?: string | undefined;
  thirdFieldID?: string | undefined;
  forthFieldID?: string | undefined;
  fifthFieldID?: string | undefined;
  sixthFieldID?: string | undefined;
  province?: Province;
  patientFirstName?: string | undefined;
  patientLastName?: string | undefined;
  patientRelationToCardHolder?: string | undefined;
  drugIdentifier?: string | undefined;
  dateOfBirth?: Date;
  requestStatus?: RequestStatus;
  drugResponseOptionID?: number | undefined;
  drugResponseOtherText?: string | undefined;
  specialAuthorizationFormID?: number | undefined;
  specialAuthorizationFormStatus?: SpecialAuthorizationFormStatus;
  specialAuthorizationPdfFile?: string | undefined;
  din?: string | undefined;
  optionName?: string | undefined;

  constructor(data?: IReimbursementRequestInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.doctorID = _data["doctorID"];
      this.doctorChildAccountID = _data["doctorChildAccountID"];
      this.pharmacistUserID = _data["pharmacistUserID"];
      this.insuranceCompanyName = _data["insuranceCompanyName"];
      this.clientID = _data["clientID"];
      this.groupID = _data["groupID"];
      this.thirdFieldID = _data["thirdFieldID"];
      this.forthFieldID = _data["forthFieldID"];
      this.fifthFieldID = _data["fifthFieldID"];
      this.sixthFieldID = _data["sixthFieldID"];
      this.province = _data["province"];
      this.patientFirstName = _data["patientFirstName"];
      this.patientLastName = _data["patientLastName"];
      this.patientRelationToCardHolder = _data["patientRelationToCardHolder"];
      this.drugIdentifier = _data["drugIdentifier"];
      this.dateOfBirth = _data["dateOfBirth"]
        ? new Date(_data["dateOfBirth"].toString())
        : <any>undefined;
      this.requestStatus = _data["requestStatus"];
      this.drugResponseOptionID = _data["drugResponseOptionID"];
      this.drugResponseOtherText = _data["drugResponseOtherText"];
      this.specialAuthorizationFormID = _data["specialAuthorizationFormID"];
      this.specialAuthorizationFormStatus = _data["specialAuthorizationFormStatus"];
      this.specialAuthorizationPdfFile = _data["specialAuthorizationPdfFile"];
      this.din = _data["din"];
      this.optionName = _data["optionName"];
    }
  }

  static fromJS(data: any): ReimbursementRequestInfo {
    data = typeof data === "object" ? data : {};
    let result = new ReimbursementRequestInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["doctorID"] = this.doctorID;
    data["doctorChildAccountID"] = this.doctorChildAccountID;
    data["pharmacistUserID"] = this.pharmacistUserID;
    data["insuranceCompanyName"] = this.insuranceCompanyName;
    data["clientID"] = this.clientID;
    data["groupID"] = this.groupID;
    data["thirdFieldID"] = this.thirdFieldID;
    data["forthFieldID"] = this.forthFieldID;
    data["fifthFieldID"] = this.fifthFieldID;
    data["sixthFieldID"] = this.sixthFieldID;
    data["province"] = this.province;
    data["patientFirstName"] = this.patientFirstName;
    data["patientLastName"] = this.patientLastName;
    data["patientRelationToCardHolder"] = this.patientRelationToCardHolder;
    data["drugIdentifier"] = this.drugIdentifier;
    data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
    data["requestStatus"] = this.requestStatus;
    data["drugResponseOptionID"] = this.drugResponseOptionID;
    data["drugResponseOtherText"] = this.drugResponseOtherText;
    data["specialAuthorizationFormID"] = this.specialAuthorizationFormID;
    data["specialAuthorizationFormStatus"] = this.specialAuthorizationFormStatus;
    data["specialAuthorizationPdfFile"] = this.specialAuthorizationPdfFile;
    data["din"] = this.din;
    data["optionName"] = this.optionName;
    return data;
  }
}

export interface IReimbursementRequestInfo {
  doctorID?: string;
  doctorChildAccountID?: string | undefined;
  pharmacistUserID?: string | undefined;
  insuranceCompanyName?: string | undefined;
  clientID?: string | undefined;
  groupID?: string | undefined;
  thirdFieldID?: string | undefined;
  forthFieldID?: string | undefined;
  fifthFieldID?: string | undefined;
  sixthFieldID?: string | undefined;
  province?: Province;
  patientFirstName?: string | undefined;
  patientLastName?: string | undefined;
  patientRelationToCardHolder?: string | undefined;
  drugIdentifier?: string | undefined;
  dateOfBirth?: Date;
  requestStatus?: RequestStatus;
  drugResponseOptionID?: number | undefined;
  drugResponseOtherText?: string | undefined;
  specialAuthorizationFormID?: number | undefined;
  specialAuthorizationFormStatus?: SpecialAuthorizationFormStatus;
  specialAuthorizationPdfFile?: string | undefined;
  din?: string | undefined;
  optionName?: string | undefined;
}

export class Drug implements IDrug {
  drugIdentifier?: string | undefined;
  name?: string | undefined;
  photoUrl?: string | undefined;
  notes?: string | undefined;
  status?: EntityStatus;
  createdOn?: Date;
  keyInformation?: string | undefined;
  otherConsiderations?: string | undefined;
  moreInformationUrl?: string | undefined;
  patientInformation?: string | undefined;
  orderIndex?: number;
  createdBy?: string;
  modifiedOn?: Date | undefined;
  modifiedBy?: string | undefined;

  constructor(data?: IDrug) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.drugIdentifier = _data["drugIdentifier"];
      this.name = _data["name"];
      this.photoUrl = _data["photoUrl"];
      this.notes = _data["notes"];
      this.status = _data["status"];
      this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
      this.keyInformation = _data["keyInformation"];
      this.otherConsiderations = _data["otherConsiderations"];
      this.moreInformationUrl = _data["moreInformationUrl"];
      this.patientInformation = _data["patientInformation"];
      this.orderIndex = _data["orderIndex"];
      this.createdBy = _data["createdBy"];
      this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
      this.modifiedBy = _data["modifiedBy"];
    }
  }

  static fromJS(data: any): Drug {
    data = typeof data === "object" ? data : {};
    let result = new Drug();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["drugIdentifier"] = this.drugIdentifier;
    data["name"] = this.name;
    data["photoUrl"] = this.photoUrl;
    data["notes"] = this.notes;
    data["status"] = this.status;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
    data["keyInformation"] = this.keyInformation;
    data["otherConsiderations"] = this.otherConsiderations;
    data["moreInformationUrl"] = this.moreInformationUrl;
    data["patientInformation"] = this.patientInformation;
    data["orderIndex"] = this.orderIndex;
    data["createdBy"] = this.createdBy;
    data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
    data["modifiedBy"] = this.modifiedBy;
    return data;
  }
}

export interface IDrug {
  drugIdentifier?: string | undefined;
  name?: string | undefined;
  photoUrl?: string | undefined;
  notes?: string | undefined;
  status?: EntityStatus;
  createdOn?: Date;
  keyInformation?: string | undefined;
  otherConsiderations?: string | undefined;
  moreInformationUrl?: string | undefined;
  patientInformation?: string | undefined;
  orderIndex?: number;
  createdBy?: string;
  modifiedOn?: Date | undefined;
  modifiedBy?: string | undefined;
}

export enum SpecialAuthorizationScope {
  _0 = 0,
  _1 = 1
}

export class InsuranceCompany implements IInsuranceCompany {
  insuranceCompanyID?: number;
  companyName?: string | undefined;
  adjudicator?: string | undefined;
  carrierId?: string | undefined;
  clientIdFormat?: string | undefined;
  groupIdFormat?: string | undefined;
  clientIdName?: string | undefined;
  groupIdName?: string | undefined;
  thirdFieldName?: string | undefined;
  thirdFieldFormat?: string | undefined;
  forthFieldName?: string | undefined;
  forthFieldFormat?: string | undefined;
  fifthFieldName?: string | undefined;
  fifthFieldFormat?: string | undefined;
  sixthFieldName?: string | undefined;
  sixthFieldFormat?: string | undefined;
  createdOn?: Date;
  createdBy?: string;
  modifiedOn?: Date | undefined;
  modifiedBy?: string | undefined;
  status?: EntityStatus;

  constructor(data?: IInsuranceCompany) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.insuranceCompanyID = _data["insuranceCompanyID"];
      this.companyName = _data["companyName"];
      this.adjudicator = _data["adjudicator"];
      this.carrierId = _data["carrierId"];
      this.clientIdFormat = _data["clientIdFormat"];
      this.groupIdFormat = _data["groupIdFormat"];
      this.clientIdName = _data["clientIdName"];
      this.groupIdName = _data["groupIdName"];
      this.thirdFieldName = _data["thirdFieldName"];
      this.thirdFieldFormat = _data["thirdFieldFormat"];
      this.forthFieldName = _data["forthFieldName"];
      this.forthFieldFormat = _data["forthFieldFormat"];
      this.fifthFieldName = _data["fifthFieldName"];
      this.fifthFieldFormat = _data["fifthFieldFormat"];
      this.sixthFieldName = _data["sixthFieldName"];
      this.sixthFieldFormat = _data["sixthFieldFormat"];
      this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
      this.createdBy = _data["createdBy"];
      this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
      this.modifiedBy = _data["modifiedBy"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): InsuranceCompany {
    data = typeof data === "object" ? data : {};
    let result = new InsuranceCompany();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["insuranceCompanyID"] = this.insuranceCompanyID;
    data["companyName"] = this.companyName;
    data["adjudicator"] = this.adjudicator;
    data["carrierId"] = this.carrierId;
    data["clientIdFormat"] = this.clientIdFormat;
    data["groupIdFormat"] = this.groupIdFormat;
    data["clientIdName"] = this.clientIdName;
    data["groupIdName"] = this.groupIdName;
    data["thirdFieldName"] = this.thirdFieldName;
    data["thirdFieldFormat"] = this.thirdFieldFormat;
    data["forthFieldName"] = this.forthFieldName;
    data["forthFieldFormat"] = this.forthFieldFormat;
    data["fifthFieldName"] = this.fifthFieldName;
    data["fifthFieldFormat"] = this.fifthFieldFormat;
    data["sixthFieldName"] = this.sixthFieldName;
    data["sixthFieldFormat"] = this.sixthFieldFormat;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
    data["createdBy"] = this.createdBy;
    data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
    data["modifiedBy"] = this.modifiedBy;
    data["status"] = this.status;
    return data;
  }
}

export interface IInsuranceCompany {
  insuranceCompanyID?: number;
  companyName?: string | undefined;
  adjudicator?: string | undefined;
  carrierId?: string | undefined;
  clientIdFormat?: string | undefined;
  groupIdFormat?: string | undefined;
  clientIdName?: string | undefined;
  groupIdName?: string | undefined;
  thirdFieldName?: string | undefined;
  thirdFieldFormat?: string | undefined;
  forthFieldName?: string | undefined;
  forthFieldFormat?: string | undefined;
  fifthFieldName?: string | undefined;
  fifthFieldFormat?: string | undefined;
  sixthFieldName?: string | undefined;
  sixthFieldFormat?: string | undefined;
  createdOn?: Date;
  createdBy?: string;
  modifiedOn?: Date | undefined;
  modifiedBy?: string | undefined;
  status?: EntityStatus;
}

export class SpecialAuthorizationForm implements ISpecialAuthorizationForm {
  specialAuthorizationFormID?: number;
  drugIdentifier?: string | undefined;
  drug?: Drug;
  filename?: string | undefined;
  pdfFile?: string | undefined;
  title?: string | undefined;
  scope?: SpecialAuthorizationScope;
  status?: EntityStatus;
  province?: Province;
  insuranceCompanyID?: number | undefined;
  insuranceCompany?: InsuranceCompany;
  readonly insuranceCompanyName?: string | undefined;

  constructor(data?: ISpecialAuthorizationForm) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.specialAuthorizationFormID = _data["specialAuthorizationFormID"];
      this.drugIdentifier = _data["drugIdentifier"];
      this.drug = _data["drug"] ? Drug.fromJS(_data["drug"]) : <any>undefined;
      this.filename = _data["filename"];
      this.pdfFile = _data["pdfFile"];
      this.title = _data["title"];
      this.scope = _data["scope"];
      this.status = _data["status"];
      this.province = _data["province"];
      this.insuranceCompanyID = _data["insuranceCompanyID"];
      this.insuranceCompany = _data["insuranceCompany"]
        ? InsuranceCompany.fromJS(_data["insuranceCompany"])
        : <any>undefined;
      (<any>this).insuranceCompanyName = _data["insuranceCompanyName"];
    }
  }

  static fromJS(data: any): SpecialAuthorizationForm {
    data = typeof data === "object" ? data : {};
    let result = new SpecialAuthorizationForm();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["specialAuthorizationFormID"] = this.specialAuthorizationFormID;
    data["drugIdentifier"] = this.drugIdentifier;
    data["drug"] = this.drug ? this.drug.toJSON() : <any>undefined;
    data["filename"] = this.filename;
    data["pdfFile"] = this.pdfFile;
    data["title"] = this.title;
    data["scope"] = this.scope;
    data["status"] = this.status;
    data["province"] = this.province;
    data["insuranceCompanyID"] = this.insuranceCompanyID;
    data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
    data["insuranceCompanyName"] = this.insuranceCompanyName;
    return data;
  }
}

export interface ISpecialAuthorizationForm {
  specialAuthorizationFormID?: number;
  drugIdentifier?: string | undefined;
  drug?: Drug;
  filename?: string | undefined;
  pdfFile?: string | undefined;
  title?: string | undefined;
  scope?: SpecialAuthorizationScope;
  status?: EntityStatus;
  province?: Province;
  insuranceCompanyID?: number | undefined;
  insuranceCompany?: InsuranceCompany;
  insuranceCompanyName?: string | undefined;
}

export enum UserType {
  _1 = 1,
  _2 = 2
}

export class NewUserInfo implements INewUserInfo {
  applicationID?: string;
  userType?: UserType;
  email?: string | undefined;
  companyName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  newPassword?: string | undefined;
  confirmPassword?: string | undefined;

  constructor(data?: INewUserInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.applicationID = _data["applicationID"];
      this.userType = _data["userType"];
      this.email = _data["email"];
      this.companyName = _data["companyName"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.newPassword = _data["newPassword"];
      this.confirmPassword = _data["confirmPassword"];
    }
  }

  static fromJS(data: any): NewUserInfo {
    data = typeof data === "object" ? data : {};
    let result = new NewUserInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["applicationID"] = this.applicationID;
    data["userType"] = this.userType;
    data["email"] = this.email;
    data["companyName"] = this.companyName;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["newPassword"] = this.newPassword;
    data["confirmPassword"] = this.confirmPassword;
    return data;
  }
}

export interface INewUserInfo {
  applicationID?: string;
  userType?: UserType;
  email?: string | undefined;
  companyName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  newPassword?: string | undefined;
  confirmPassword?: string | undefined;
}

export enum OnlineStatus {
  _1 = 1,
  _2 = 2
}

export class UserInfo implements IUserInfo {
  userType?: UserType;
  email?: string | undefined;
  companyName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  onlineStatus?: OnlineStatus;

  constructor(data?: IUserInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userType = _data["userType"];
      this.email = _data["email"];
      this.companyName = _data["companyName"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.onlineStatus = _data["onlineStatus"];
    }
  }

  static fromJS(data: any): UserInfo {
    data = typeof data === "object" ? data : {};
    let result = new UserInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userType"] = this.userType;
    data["email"] = this.email;
    data["companyName"] = this.companyName;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["onlineStatus"] = this.onlineStatus;
    return data;
  }
}

export interface IUserInfo {
  userType?: UserType;
  email?: string | undefined;
  companyName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  onlineStatus?: OnlineStatus;
}

export class UserTokenRequest implements IUserTokenRequest {
  username!: string;
  password!: string;

  constructor(data?: IUserTokenRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.username = _data["username"];
      this.password = _data["password"];
    }
  }

  static fromJS(data: any): UserTokenRequest {
    data = typeof data === "object" ? data : {};
    let result = new UserTokenRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["username"] = this.username;
    data["password"] = this.password;
    return data;
  }
}

export interface IUserTokenRequest {
  username: string;
  password: string;
}

export class ChangePasswordInfo implements IChangePasswordInfo {
  newPassword?: string | undefined;
  confirmPassword?: string | undefined;

  constructor(data?: IChangePasswordInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.newPassword = _data["newPassword"];
      this.confirmPassword = _data["confirmPassword"];
    }
  }

  static fromJS(data: any): ChangePasswordInfo {
    data = typeof data === "object" ? data : {};
    let result = new ChangePasswordInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["newPassword"] = this.newPassword;
    data["confirmPassword"] = this.confirmPassword;
    return data;
  }
}

export interface IChangePasswordInfo {
  newPassword?: string | undefined;
  confirmPassword?: string | undefined;
}

export class ChangeUserPasswordInfo implements IChangeUserPasswordInfo {
  userID?: string;
  newPassword?: string | undefined;
  confirmPassword?: string | undefined;

  constructor(data?: IChangeUserPasswordInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userID = _data["userID"];
      this.newPassword = _data["newPassword"];
      this.confirmPassword = _data["confirmPassword"];
    }
  }

  static fromJS(data: any): ChangeUserPasswordInfo {
    data = typeof data === "object" ? data : {};
    let result = new ChangeUserPasswordInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userID"] = this.userID;
    data["newPassword"] = this.newPassword;
    data["confirmPassword"] = this.confirmPassword;
    return data;
  }
}

export interface IChangeUserPasswordInfo {
  userID?: string;
  newPassword?: string | undefined;
  confirmPassword?: string | undefined;
}

export class InitiateResetPasswordInfo implements IInitiateResetPasswordInfo {
  email?: string | undefined;

  constructor(data?: IInitiateResetPasswordInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
    }
  }

  static fromJS(data: any): InitiateResetPasswordInfo {
    data = typeof data === "object" ? data : {};
    let result = new InitiateResetPasswordInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["email"] = this.email;
    return data;
  }
}

export interface IInitiateResetPasswordInfo {
  email?: string | undefined;
}

export class ResetPasswordInfo implements IResetPasswordInfo {
  email?: string | undefined;
  token?: string | undefined;
  newPassword?: string | undefined;
  confirmPassword?: string | undefined;

  constructor(data?: IResetPasswordInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
      this.token = _data["token"];
      this.newPassword = _data["newPassword"];
      this.confirmPassword = _data["confirmPassword"];
    }
  }

  static fromJS(data: any): ResetPasswordInfo {
    data = typeof data === "object" ? data : {};
    let result = new ResetPasswordInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["email"] = this.email;
    data["token"] = this.token;
    data["newPassword"] = this.newPassword;
    data["confirmPassword"] = this.confirmPassword;
    return data;
  }
}

export interface IResetPasswordInfo {
  email?: string | undefined;
  token?: string | undefined;
  newPassword?: string | undefined;
  confirmPassword?: string | undefined;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}

// Vuex
